(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mn-ann-slider')) {
    customElements.define(
      'mn-ann-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.mn-ann-slides');
          this.count = this.track.children.length;
          this.index = 0;
          this.querySelectorAll('.mn-ann-arrow').forEach((btn) => {
            btn.addEventListener('click', () => {
              this.go(this.index + Number(btn.dataset.dir));
              this.restart();
            });
          });
          this.addEventListener('mouseenter', () => clearInterval(this.timer));
          this.addEventListener('mouseleave', () => this.restart());
          let startX = null;
          this.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
          this.addEventListener('touchend', (e) => {
            if (startX === null) return;
            const dx = e.changedTouches[0].clientX - startX;
            if (Math.abs(dx) > 30) this.go(this.index + (dx < 0 ? 1 : -1));
            startX = null;
            this.restart();
          });
          this.restart();
        }

        restart() {
          clearInterval(this.timer);
          if (this.count < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.timer = setInterval(() => this.go(this.index + 1), (Number(this.dataset.interval) || 4) * 1000);
        }

        go(i) {
          this.index = (i + this.count) % this.count;
          this.track.style.transform = `translateX(-${this.index * 100}%)`;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complete-look"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-ctl-addall]');
    if (!btn) return;
    const section = btn.closest('.ctl');
    const items = [...section.querySelectorAll('[data-variant-id]')].map((el) => ({ id: Number(el.dataset.variantId), quantity: 1 }));
    if (items.length === 0) return;
    btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    })
      .then((res) => {
        if (!res.ok) throw new Error();
        if (window.mnCart) return window.mnCart.refresh().then(() => window.mnCart.open());
        window.location.href = '/cart';
      })
      .catch(() => window.alert(btn.dataset.error))
      .finally(() => btn.removeAttribute('aria-busy'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const order = new URLSearchParams(window.location.search).get('order');
    if (!order) return;
    document.querySelectorAll('textarea[data-prefill]').forEach((area) => {
      if (!area.value) area.value = area.dataset.prefill.replace('[order]', order);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mn-countdown')) {
    customElements.define(
      'mn-countdown',
      class extends HTMLElement {
        connectedCallback() {
          const raw = (this.dataset.end || '').trim().replace(' ', 'T');
          this.end = new Date(raw.length <= 16 ? raw + ':00' : raw).getTime();
          if (Number.isNaN(this.end)) return;
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        tick() {
          let left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
          const set = (unit, value) => {
            const el = this.querySelector(`[data-unit="${unit}"]`);
            if (el) el.textContent = String(value).padStart(2, '0');
          };
          set('d', Math.floor(left / 86400));
          set('h', Math.floor((left % 86400) / 3600));
          set('m', Math.floor((left % 3600) / 60));
          set('s', left % 60);
          if (left === 0) {
            clearInterval(this.timer);
            if (this.dataset.hide === 'true') {
              const section = this.closest('.cdn');
              if (section) section.hidden = true;
            } else {
              this.querySelector('.cdn-clock').hidden = true;
              this.querySelector('.cdn-done').hidden = false;
            }
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('mn-header')) {
    customElements.define(
      'mn-header',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('.mn-menu');
          this.opener = this.querySelector('[data-menu-open]');
          const toggle = this.querySelector('[data-search-toggle]');
          if (toggle) {
            toggle.addEventListener('click', () => {
              const box = this.querySelector('.mn-msearch');
              box.hidden = !box.hidden;
              toggle.setAttribute('aria-expanded', box.hidden ? 'false' : 'true');
              if (!box.hidden) box.querySelector('input[type="search"]').focus();
            });
          }
          if (!this.dialog || !this.opener) return;
          this.opener.addEventListener('click', () => this.open());
          this.dialog.querySelector('[data-menu-close]').addEventListener('click', () => this.close());
          this.dialog.addEventListener('close', () => {
            this.opener.setAttribute('aria-expanded', 'false');
            document.documentElement.classList.remove('mn-menu-lock');
          });
          this.dialog.querySelectorAll('summary a').forEach((a) => {
            a.addEventListener('click', (event) => event.stopPropagation());
          });
          const track = this.dialog.querySelector('[data-menu-track]');
          this.dialog.querySelectorAll('.mn-menu-arrow').forEach((btn) => {
            btn.addEventListener('click', () => {
              track.scrollBy({ left: Number(btn.dataset.dir) * track.clientWidth * 0.8, behavior: 'smooth' });
            });
          });
        }

        open() {
          this.dialog.showModal();
          this.opener.setAttribute('aria-expanded', 'true');
          document.documentElement.classList.add('mn-menu-lock');
        }

        close() {
          this.dialog.close();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["look-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mn-bundle')) {
    customElements.define(
      'mn-bundle',
      class extends HTMLElement {
        connectedCallback() {
          this.items = [...this.querySelectorAll('[data-lb-item]')];
          this.items.forEach((item) => {
            item.querySelectorAll('select, input[type="checkbox"]').forEach((el) => el.addEventListener('change', () => this.update()));
          });
          this.querySelectorAll('.lb-dot').forEach((dot) => {
            dot.addEventListener('click', () => {
              const item = this.querySelector(`[data-lb-item][data-index="${dot.dataset.target}"]`);
              if (!item) return;
              item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              item.classList.add('lb-flash');
              setTimeout(() => item.classList.remove('lb-flash'), 900);
            });
          });
          this.querySelector('[data-lb-add]').addEventListener('click', () => this.add());
          this.update();
        }

        applyMoney(value) {
          const open = String.fromCharCode(123, 123);
          const close = String.fromCharCode(125, 125);
          const format = this.dataset.money || 'amount';
          const re = new RegExp(open.replace(/./g, '\\$&') + '\\s*amount[a-z_]*\\s*' + close.replace(/./g, '\\$&'));
          return re.test(format) ? format.replace(re, value) : value;
        }

        money(cents) {
          const value = (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          return this.applyMoney(value);
        }

        selected() {
          return this.items
            .filter((item) => item.querySelector('input[type="checkbox"]').checked)
            .map((item) => {
              const select = item.querySelector('select');
              const option = select ? select.selectedOptions[0] : item.querySelector('[data-variant]');
              return { id: Number(option.value || option.dataset.variant), price: Number(option.dataset.price), available: option.dataset.available === 'true' };
            });
        }

        update() {
          const list = this.selected();
          const total = list.reduce((sum, v) => sum + v.price, 0);
          const pct = Number(this.dataset.percent) || 0;
          const finalTotal = pct > 0 && list.length > 1 ? Math.round(total * (100 - pct) / 100) : total;
          this.querySelector('[data-lb-count]').textContent = list.length;
          this.querySelector('[data-lb-total]').textContent = this.money(finalTotal);
          const old = this.querySelector('[data-lb-old]');
          old.hidden = finalTotal === total;
          old.textContent = this.money(total);
          this.items.forEach((item) => {
            const select = item.querySelector('select');
            const option = select ? select.selectedOptions[0] : item.querySelector('[data-variant]');
            const price = item.querySelector('[data-lb-price]');
            if (price && option) price.textContent = this.money(Number(option.dataset.price));
          });
          const btn = this.querySelector('[data-lb-add]');
          btn.disabled = list.length === 0 || list.some((v) => !v.available);
        }

        add() {
          const items = this.selected().map((v) => ({ id: v.id, quantity: 1 }));
          if (items.length === 0) return;
          const btn = this.querySelector('[data-lb-add]');
          btn.setAttribute('aria-busy', 'true');
          const code = this.dataset.code;
          const pre = code ? fetch(`/discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' }).catch(() => {}) : Promise.resolve();
          pre
            .then(() =>
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items }),
              })
            )
            .then((res) => {
              if (!res.ok) throw new Error();
              if (window.mnCart) return window.mnCart.refresh().then(() => window.mnCart.open());
              window.location.href = '/cart';
            })
            .catch(() => {
              this.querySelector('[data-lb-msg]').hidden = false;
            })
            .finally(() => btn.removeAttribute('aria-busy'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
  if (!customElements.get('mn-tabs')) {
    customElements.define(
      'mn-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.querySelectorAll('[data-tab]').forEach((tab) => {
            tab.addEventListener('click', () => this.show(tab.dataset.tab));
          });
          const hash = window.location.hash.replace('#', '');
          if (hash && this.querySelector(`[data-panel="${hash}"]`)) this.show(hash);
        }

        show(name) {
          this.querySelectorAll('[data-tab]').forEach((tab) => {
            const on = tab.dataset.tab === name;
            tab.classList.toggle('on', on);
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          this.querySelectorAll('[data-panel]').forEach((panel) => {
            panel.hidden = panel.dataset.panel !== name;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!customElements.get('mn-collection')) {
    customElements.define(
      'mn-collection',
      class extends HTMLElement {
        connectedCallback() {
          this.grid = this.querySelector('[data-grid]');
          this.apply();
          this.querySelectorAll('[data-layout]').forEach((btn) => {
            btn.addEventListener('click', () => {
              try {
                localStorage.setItem(`mn-cols-${btn.dataset.device}`, btn.dataset.layout);
              } catch (e) {}
              this.apply();
            });
          });
          const sort = this.querySelector('[data-sort]');
          if (sort) {
            sort.addEventListener('change', () => {
              const url = new URL(window.location.href);
              url.searchParams.set('sort_by', sort.value);
              url.searchParams.delete('page');
              window.location.href = url.toString();
            });
          }
          this.setupMore();
          const drawer = this.querySelector('.mc-drawer');
          const opener = this.querySelector('[data-filter-open]');
          if (drawer && opener) {
            opener.addEventListener('click', () => drawer.showModal());
            drawer.querySelector('[data-filter-close]').addEventListener('click', () => drawer.close());
            drawer.addEventListener('click', (event) => {
              if (event.target === drawer) drawer.close();
            });
          }
        }

        setupMore() {
          const btn = this.querySelector('[data-load-more]');
          if (!btn || !this.grid) return;
          const load = () => {
            if (this.loading || !btn.isConnected) return;
            this.loading = true;
            btn.setAttribute('aria-busy', 'true');
            fetch(btn.href)
              .then((res) => res.text())
              .then((html) => {
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const grid = doc.querySelector('[data-grid]');
                if (grid) this.grid.append(...[...grid.children].map((el) => document.importNode(el, true)));
                const nextWrap = doc.querySelector('[data-more-wrap]');
                const wrap = this.querySelector('[data-more-wrap]');
                if (nextWrap) {
                  wrap.innerHTML = nextWrap.innerHTML;
                  this.setupMore();
                } else {
                  wrap.remove();
                }
                if (window.mnWishlist) window.mnWishlist.paint();
              })
              .finally(() => {
                this.loading = false;
              });
          };
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            load();
          });
          if (btn.dataset.mode === 'infinite' && 'IntersectionObserver' in window) {
            const io = new IntersectionObserver(
              (entries) => {
                if (entries[0].isIntersecting) {
                  io.disconnect();
                  load();
                }
              },
              { rootMargin: '0px 0px 600px 0px' }
            );
            io.observe(btn);
          }
        }

        stored(device) {
          try {
            return localStorage.getItem(`mn-cols-${device}`);
          } catch (e) {
            return null;
          }
        }

        apply() {
          const d = this.stored('d') || this.dataset.colsD;
          const m = this.stored('m') || this.dataset.colsM;
          if (this.grid) {
            this.grid.style.setProperty('--cols-d', d);
            this.grid.style.setProperty('--cols-m', m);
          }
          this.querySelectorAll('[data-layout]').forEach((btn) => {
            const current = btn.dataset.device === 'd' ? d : m;
            btn.classList.toggle('on', btn.dataset.layout === String(current));
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-compare"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mn-compare-page')) {
    customElements.define(
      'mn-compare-page',
      class extends HTMLElement {
        connectedCallback() {
          this.labels = JSON.parse(this.dataset.labels);
          const bar = document.querySelector('[data-compare-bar]');
          if (bar) {
            bar.setAttribute('data-on-compare-page', '');
            bar.hidden = true;
          }
          document.addEventListener('compare:change', () => this.render());
          this.render();
        }

        applyMoney(value) {
          const open = String.fromCharCode(123, 123);
          const close = String.fromCharCode(125, 125);
          const format = this.dataset.money || 'amount';
          const re = new RegExp(open.replace(/./g, '\\$&') + '\\s*amount[a-z_]*\\s*' + close.replace(/./g, '\\$&'));
          return re.test(format) ? format.replace(re, value) : value;
        }

        money(cents) {
          const value = (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          return this.applyMoney(value);
        }

        esc(text) {
          const div = document.createElement('div');
          div.textContent = text == null ? '' : String(text);
          return div.innerHTML;
        }

        render() {
          const list = window.mnCompare ? window.mnCompare.read() : [];
          const table = this.querySelector('[data-cmp-table]');
          const empty = this.querySelector('[data-cmp-empty]');
          if (list.length === 0) {
            table.innerHTML = '';
            empty.hidden = false;
            return;
          }
          empty.hidden = true;
          Promise.all(
            list.map((item) =>
              fetch(`/products/${encodeURIComponent(item.handle)}.js`)
                .then((res) => (res.ok ? res.json() : null))
                .catch(() => null)
            )
          ).then((products) => {
            products = products.filter(Boolean);
            const L = this.labels;
            const optionNames = [...new Set(products.flatMap((p) => p.options.map((o) => o.name)))].filter(
              (n) => n !== 'Title'
            );
            const cell = (fn) => products.map((p) => `<td>${fn(p)}</td>`).join('');
            const rows = [];
            rows.push(
              `<tr class="cmp-head"><th></th>${cell(
                (p) => `
                <div class="cmp-prod">
                  <button type="button" class="cmp-x" data-compare-remove="${this.esc(p.handle)}" aria-label="${this.esc(L.remove)}">×</button>
                  <a href="${p.url}">${p.featured_image ? `<img src="${p.featured_image}&width=400" alt="">` : ''}</a>
                  <a class="cmp-name" href="${p.url}">${this.esc(p.title)}</a>
                  <a class="cmp-view" href="${p.url}">${this.esc(L.view)}</a>
                </div>`
              )}</tr>`
            );
            rows.push(
              `<tr><th>${L.price}</th>${cell(
                (p) =>
                  `${p.compare_at_price > p.price ? `<s>${this.money(p.compare_at_price)}</s> ` : ''}<b>${this.money(p.price)}</b>`
              )}</tr>`
            );
            rows.push(`<tr><th>${L.availability}</th>${cell((p) => (p.available ? L.in : L.out))}</tr>`);
            optionNames.forEach((name) => {
              rows.push(
                `<tr><th>${this.esc(name)}</th>${cell((p) => {
                  const o = p.options.find((x) => x.name === name);
                  return o ? o.values.map((v) => this.esc(v)).join(', ') : '–';
                })}</tr>`
              );
            });
            rows.push(`<tr><th>${L.vendor}</th>${cell((p) => this.esc(p.vendor) || '–')}</tr>`);
            rows.push(`<tr><th>${L.type}</th>${cell((p) => this.esc(p.type) || '–')}</tr>`);
            rows.push(
              `<tr><th>${L.desc}</th>${cell((p) => {
                const div = document.createElement('div');
                div.innerHTML = p.description || '';
                const text = div.textContent.trim();
                return this.esc(text.length > 220 ? text.slice(0, 220) + '…' : text);
              })}</tr>`
            );
            table.innerHTML = `<table class="cmp-table">${rows.join('')}</table>`;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mn-wishlist-page')) {
    customElements.define(
      'mn-wishlist-page',
      class extends HTMLElement {
        connectedCallback() {
          const params = new URLSearchParams(window.location.search);
          this.shared = params.get('items') ? params.get('items').split(',').filter(Boolean) : null;
          this.grid = this.querySelector('[data-wl-grid]');
          this.querySelector('[data-wl-addall]').addEventListener('click', () => this.addAll());
          this.querySelector('[data-wl-share]').addEventListener('click', (e) => this.share(e.currentTarget));
          this.querySelector('[data-wl-clear]').addEventListener('click', (e) => {
            if (!window.confirm(e.currentTarget.dataset.confirm)) return;
            if (window.mnWishlist) window.mnWishlist.write([]);
            document.dispatchEvent(new CustomEvent('wishlist:change'));
          });
          this.querySelector('[data-wl-save]').addEventListener('click', () => {
            const mine = window.mnWishlist ? window.mnWishlist.read() : [];
            const merged = [...new Set([...this.shared, ...mine])];
            if (window.mnWishlist) window.mnWishlist.write(merged);
            window.location.href = window.location.pathname;
          });
          document.addEventListener('wishlist:change', () => {
            if (!this.shared) this.render();
          });
          this.render();
        }

        list() {
          if (this.shared) return this.shared;
          return window.mnWishlist ? window.mnWishlist.read() : [];
        }

        render() {
          const list = this.list();
          this.querySelector('[data-wl-shared]').hidden = !this.shared;
          this.querySelector('[data-wl-count]').textContent = list.length ? `(${list.length})` : '';
          if (list.length === 0) {
            this.grid.innerHTML = '';
            this.grid.hidden = true;
            this.querySelector('[data-wl-empty]').hidden = false;
            this.querySelector('[data-wl-actions]').hidden = true;
            return;
          }
          this.querySelector('[data-wl-empty]').hidden = true;
          Promise.all(
            list.map((handle) =>
              fetch(`/products/${encodeURIComponent(handle)}?section_id=card-render`)
                .then((res) => (res.ok ? res.text() : ''))
                .catch(() => '')
            )
          ).then((pages) => {
            this.variants = [];
            const cards = pages
              .map((html) => {
                const box = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-card-render]');
                if (!box) return '';
                if (box.dataset.variantId) this.variants.push(Number(box.dataset.variantId));
                return box.innerHTML.trim();
              })
              .filter(Boolean);
            this.grid.hidden = cards.length === 0;
            this.grid.innerHTML = cards.join('');
            this.querySelector('[data-wl-empty]').hidden = cards.length > 0;
            this.querySelector('[data-wl-actions]').hidden = cards.length === 0;
            this.querySelector('[data-wl-addall]').hidden = this.variants.length === 0;
            if (window.mnWishlist) window.mnWishlist.paint();
          });
        }

        message(text) {
          const msg = this.querySelector('[data-wl-msg]');
          msg.textContent = text;
          msg.hidden = false;
          clearTimeout(this.msgTimer);
          this.msgTimer = setTimeout(() => (msg.hidden = true), 3000);
        }

        addAll() {
          if (!this.variants || this.variants.length === 0) return;
          const items = this.variants.map((id) => ({ id, quantity: 1 }));
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          })
            .then((res) => {
              if (!res.ok) throw new Error();
              if (window.mnCart) return window.mnCart.refresh().then(() => window.mnCart.open());
              window.location.href = '/cart';
            })
            .catch(() => this.message(this.dataset.error));
        }

        share(btn) {
          const url = `${window.location.origin}${window.location.pathname}?items=${this.list().join(',')}`;
          if (navigator.share) {
            navigator.share({ url }).catch(() => {});
            return;
          }
          const done = () => this.message(btn.dataset.copied);
          if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-tracking"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mn-tracking')) {
    customElements.define(
      'mn-tracking',
      class extends HTMLElement {
        connectedCallback() {
          const select = this.querySelector('[data-carrier]');
          this.carriers = (this.dataset.carriers || '')
            .split('\n')
            .map((line) => line.split('|').map((x) => x.trim()))
            .filter((p) => p.length === 2 && p[1].startsWith('http'));
          this.carriers.forEach((c, i) => {
            const option = document.createElement('option');
            option.value = i;
            option.textContent = c[0];
            select.appendChild(option);
          });
          this.querySelector('[data-track-form]').addEventListener('submit', (event) => {
            event.preventDefault();
            const carrier = this.carriers[Number(select.value)];
            const code = this.querySelector('[data-code]').value.trim();
            if (!carrier || !code) return;
            window.open(carrier[1].replace('[kod]', encodeURIComponent(code)), '_blank', 'noopener');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mn-popup')) {
    customElements.define(
      'mn-popup',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.querySelectorAll('[data-pp-close]').forEach((el) => el.addEventListener('click', () => this.close()));
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close();
          });
          if (this.hasAttribute('data-editor')) return;
          if (window.location.search.indexOf('customer_posted=true') > -1 || this.querySelector('.pp-msg')) {
            this.open();
            return;
          }
          if (this.seen()) return;
          setTimeout(() => this.open(), (Number(this.dataset.delay) || 0) * 1000);
        }

        seen() {
          try {
            const at = Number(localStorage.getItem(this.dataset.key) || 0);
            const days = Number(this.dataset.days) || 0;
            return at > 0 && Date.now() - at < days * 86400000;
          } catch (e) {
            return false;
          }
        }

        open() {
          if (!this.dialog.open) this.dialog.showModal();
        }

        close() {
          this.dialog.close();
          try {
            localStorage.setItem(this.dataset.key, String(Date.now()));
          } catch (e) {}
        }
      }
    );
    document.addEventListener('shopify:section:select', (event) => {
      const el = event.target.querySelector('mn-popup');
      if (el) el.open();
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      const el = event.target.querySelector('mn-popup');
      if (el) el.dialog.close();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail"]) return;
  try {
    
  if (!customElements.get('mn-product')) {
    customElements.define(
      'mn-product',
      class extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
          this.colorIndex = Number(this.dataset.colorIndex);
          this.lowStock = Number(this.dataset.lowStock) || 0;
          const input = this.querySelector('[data-variant-input]');
          this.current = this.variants.find((v) => String(v.id) === input.value) || this.variants[0];
          this.selected = this.current ? [...this.current.options] : [];

          this.querySelectorAll('[data-option]').forEach((btn) => {
            btn.addEventListener('click', () => this.pick(Number(btn.dataset.option), btn.dataset.value));
          });
          this.track = this.querySelector('[data-track]');
          this.dots = this.querySelector('[data-dots]');
          this.querySelectorAll('.mn-pd-thumb').forEach((btn) => {
            btn.addEventListener('click', () => this.showMedia(btn.dataset.mediaId, true));
          });
          this.querySelectorAll('.mn-pd-arrow').forEach((btn) => {
            btn.addEventListener('click', () => this.step(Number(btn.dataset.step)));
          });
          if (this.track) {
            let ticking = false;
            this.track.addEventListener('scroll', () => {
              if (ticking) return;
              ticking = true;
              requestAnimationFrame(() => {
                ticking = false;
                this.syncActive();
              });
            });
            this.track.addEventListener('click', (event) => {
              const slide = event.target.closest('.mn-pd-slide');
              if (slide && event.target.tagName === 'IMG') this.openLightbox(slide.dataset.mediaId);
            });
          }
          this.setupLightbox();
          const thumbsToggle = this.querySelector('[data-thumbs-toggle]');
          if (thumbsToggle) {
            thumbsToggle.addEventListener('click', () => {
              const gallery = this.querySelector('[data-gallery]');
              const open = gallery.classList.toggle('thumbs-open');
              thumbsToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
            });
          }
          this.querySelectorAll('[data-row-open]').forEach((btn) => {
            const dialog = document.getElementById(btn.dataset.rowOpen);
            if (!dialog) return;
            btn.addEventListener('click', () => dialog.showModal());
            dialog.querySelector('[data-side-close]').addEventListener('click', () => dialog.close());
            dialog.addEventListener('click', (event) => {
              if (event.target === dialog) dialog.close();
            });
          });
          const sticky = this.querySelector('[data-sticky]');
          const buttons = this.querySelector('[data-buttons]') || this.querySelector('.mn-pd-form');
          if (sticky && buttons && 'IntersectionObserver' in window) {
            const io = new IntersectionObserver((entries) => {
              const e = entries[0];
              sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
            });
            io.observe(buttons);
            sticky.querySelector('[data-sticky-add]').addEventListener('click', () => {
              const form = this.querySelector('.mn-pd-form');
              const add = form && form.querySelector('.mn-pd-add');
              if (add) {
                if (form.requestSubmit) form.requestSubmit(add);
                else add.click();
              }
            });
          }
          try {
            const handle = this.dataset.handle;
            const recent = JSON.parse(localStorage.getItem('mn-recent') || '[]').filter((h) => h !== handle);
            recent.unshift(handle);
            localStorage.setItem('mn-recent', JSON.stringify(recent.slice(0, 16)));
          } catch (e) {}
          this.pickup = this.querySelector('[data-pickup]');
          if (this.pickup) this.loadPickup(this.pickup.dataset.variant);
          this.refresh(false);
          const first = this.querySelector('.mn-pd-slide.on');
          if (first) this.showMedia(first.dataset.mediaId, false);
        }

        pick(index, value) {
          this.selected[index] = value;
          let match = this.variants.find((v) => v.options.every((o, i) => o === this.selected[i]));
          if (index === this.colorIndex && (!match || !match.available)) {
            const sameColor = this.variants.filter((v) => v.options[index] === value);
            match = sameColor.find((v) => v.available) || sameColor[0] || match;
          }
          if (match) {
            this.current = match;
            this.selected = [...match.options];
          }
          this.refresh(true);
        }

        refresh(changed) {
          const v = this.current;
          if (!v) return;
          this.querySelector('[data-variant-input]').value = v.id;
          this.dispatchEvent(new CustomEvent('variant:change', { detail: { id: v.id, price: v.cents } }));

          this.querySelectorAll('[data-option]').forEach((btn) => {
            const i = Number(btn.dataset.option);
            const on = this.selected[i] === btn.dataset.value;
            btn.classList.toggle('on', on);
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
            const candidates = this.variants.filter((x) =>
              x.options.every((o, j) => {
                if (j === i) return o === btn.dataset.value;
                if (i !== this.colorIndex && j === this.colorIndex) return o === this.selected[j];
                return true;
              })
            );
            const available = candidates.some((x) => x.available);
            btn.classList.toggle('out', !available);
            if (i !== this.colorIndex) {
              const exists = candidates.length > 0;
              btn.hidden = this.colorIndex >= 0 && !exists;
              btn.disabled = !available;
            }
          });

          const price = this.querySelector('[data-price]');
          price.textContent = v.price;
          price.classList.toggle('mn-pd-price-sale', v.pct > 0);
          const old = this.querySelector('[data-old-price]');
          old.textContent = v.compare;
          old.hidden = !v.compare;
          const badge = this.querySelector('[data-badge]');
          if (badge) {
            badge.hidden = v.pct <= 0;
            badge.querySelector('[data-badge-value]').textContent = v.pct;
          }
          const pct = this.querySelector('[data-pct]');
          if (pct) {
            pct.hidden = v.pct <= 0;
            pct.querySelector('[data-pct-value]').textContent = v.pct;
          }

          const low = this.querySelector('[data-low]');
          const showLow = v.available && v.qty !== null && v.qty > 0 && v.qty <= this.lowStock;
          low.hidden = !showLow;
          if (showLow) low.textContent = this.dataset.lowStockText.replace('[count]', v.qty);

          this.querySelector('[data-buttons]').hidden = !v.available;
          this.querySelector('[data-soldout]').hidden = v.available;
          const stickyPrice = this.querySelector('[data-sticky-price]');
          if (stickyPrice) stickyPrice.textContent = v.price;
          const stickyAdd = this.querySelector('[data-sticky-add]');
          if (stickyAdd) stickyAdd.disabled = !v.available;
          const notify = this.querySelector('[data-notify]');
          if (notify) {
            notify.hidden = v.available;
            const body = notify.querySelector('[data-notify-body]');
            if (body) body.value = body.dataset.template.replace('[v]', v.title || '').replace('[id]', v.id);
          }

          this.filterMedia();
          if (changed && this.pickup) this.loadPickup(v.id);
          if (changed) {
            if (v.media) this.showMedia(String(v.media));
            const url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          }
        }

        loadPickup(id) {
          const root = (this.pickup.dataset.root || '/').replace(/\/$/, '');
          fetch(`${root}/variants/${id}/?section_id=pickup-availability`)
            .then((res) => (res.ok ? res.text() : ''))
            .then((html) => {
              const box = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pickup-content]');
              this.pickup.innerHTML = box ? box.innerHTML : '';
              const dialog = this.pickup.querySelector('[data-pickup-dialog]');
              const open = this.pickup.querySelector('[data-pickup-open]');
              if (dialog && open) {
                open.addEventListener('click', () => dialog.showModal());
                dialog.querySelector('[data-pickup-close]').addEventListener('click', () => dialog.close());
                dialog.addEventListener('click', (event) => {
                  if (event.target === dialog) dialog.close();
                });
              }
            })
            .catch(() => {});
        }

        slides() {
          return [...this.querySelectorAll('.mn-pd-slide')].filter((el) => !el.hidden);
        }

        filterMedia() {
          if (this.colorIndex < 0) {
            this.buildDots();
            return;
          }
          const color = this.selected[this.colorIndex];
          const items = [...this.querySelectorAll('[data-media-id]')].filter((el) => !el.closest('[data-lightbox]'));
          const matches = (el) => !el.dataset.color || el.dataset.color === color;
          const anyMatch = items.some((el) => el.dataset.color === color);
          items.forEach((el) => {
            el.hidden = anyMatch && !matches(el);
          });
          this.buildDots();
          const active = this.querySelector('.mn-pd-slide.on');
          if (active && active.hidden) {
            const first = this.slides()[0];
            if (first) this.showMedia(first.dataset.mediaId, false);
          }
        }

        buildDots() {
          if (!this.dots) return;
          const slides = this.slides();
          this.dots.innerHTML = '';
          if (slides.length < 2) return;
          slides.forEach((slide, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'mn-pd-dot';
            dot.setAttribute('aria-label', String(i + 1));
            dot.dataset.target = slide.dataset.mediaId;
            dot.addEventListener('click', () => this.showMedia(slide.dataset.mediaId, true));
            this.dots.appendChild(dot);
          });
          this.markActive(this.querySelector('.mn-pd-slide.on'));
        }

        markActive(slide) {
          if (!slide) return;
          const id = slide.dataset.mediaId;
          this.querySelectorAll('.mn-pd-slide').forEach((el) => el.classList.toggle('on', el === slide));
          this.querySelectorAll('.mn-pd-thumb').forEach((el) => {
            const on = el.dataset.mediaId === id;
            el.classList.toggle('on', on);
            el.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          if (this.dots) {
            const dots = [...this.dots.querySelectorAll('.mn-pd-dot')];
            const max = 5;
            let active = 0;
            dots.forEach((dot, i) => {
              const on = dot.dataset.target === id;
              if (on) active = i;
              dot.classList.toggle('on', on);
              dot.setAttribute('aria-current', on ? 'true' : 'false');
            });
            const start = Math.max(0, Math.min(active - Math.floor(max / 2), dots.length - max));
            const end = start + max - 1;
            dots.forEach((dot, i) => {
              dot.hidden = i < start || i > end;
              const edge = dots.length > max && ((i === start && start > 0) || (i === end && end < dots.length - 1));
              dot.classList.toggle('edge', edge);
            });
          }
        }

        syncActive() {
          if (!this.track) return;
          const center = this.track.scrollLeft + this.track.clientWidth / 2;
          const slide = this.slides().find((el) => el.offsetLeft <= center && el.offsetLeft + el.offsetWidth > center);
          if (slide) this.markActive(slide);
        }

        step(dir) {
          const slides = this.slides();
          const i = slides.findIndex((el) => el.classList.contains('on'));
          const next = slides[(i + dir + slides.length) % slides.length];
          if (next) this.showMedia(next.dataset.mediaId, true);
        }

        showMedia(id, smooth) {
          const slide = this.querySelector(`.mn-pd-slide[data-media-id="${id}"]`);
          if (!slide || !this.track) return;
          if (slide.hidden) return;
          this.track.scrollTo({ left: slide.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
          this.markActive(slide);
        }

        setupLightbox() {
          this.lightbox = this.querySelector('[data-lightbox]');
          if (!this.lightbox) return;
          this.lbTrack = this.lightbox.querySelector('[data-lb-track]');
          this.lbCount = this.lightbox.querySelector('[data-lb-count]');
          this.lightbox.querySelector('[data-lb-close]').addEventListener('click', () => this.lightbox.close());
          this.lightbox.querySelectorAll('[data-lb-step]').forEach((btn) => {
            btn.addEventListener('click', () => {
              this.lbTrack.scrollBy({ left: Number(btn.dataset.lbStep) * this.lbTrack.clientWidth, behavior: 'smooth' });
            });
          });
          this.lbTrack.addEventListener('scroll', () => this.updateCount());
          this.lightbox.addEventListener('close', () => document.documentElement.classList.remove('mn-menu-lock'));
        }

        updateCount() {
          const total = this.lbTrack.children.length;
          const i = Math.round(this.lbTrack.scrollLeft / this.lbTrack.clientWidth) + 1;
          this.lbCount.textContent = `${Math.min(i, total)} / ${total}`;
        }

        openLightbox(id) {
          if (!this.lightbox) return;
          this.lightbox.showModal();
          document.documentElement.classList.add('mn-menu-lock');
          const target = this.lbTrack.querySelector(`[data-lb-id="${id}"]`);
          this.lbTrack.scrollTo({ left: target ? target.offsetLeft : 0, behavior: 'auto' });
          this.updateCount();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mn-recent')) {
    customElements.define(
      'mn-recent',
      class extends HTMLElement {
        connectedCallback() {
          let list = [];
          try {
            list = JSON.parse(localStorage.getItem('mn-recent') || '[]');
          } catch (e) {}
          list = list.filter((h) => h !== this.dataset.current).slice(0, Number(this.dataset.limit) || 8);
          if (list.length === 0) return;
          const track = this.querySelector('[data-track]');
          Promise.all(
            list.map((handle) =>
              fetch(`/products/${encodeURIComponent(handle)}?section_id=card-render`)
                .then((res) => (res.ok ? res.text() : ''))
                .catch(() => '')
            )
          ).then((pages) => {
            const cards = pages
              .map((html) => {
                const box = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-card-render]');
                return box ? box.innerHTML.trim() : '';
              })
              .filter(Boolean);
            if (cards.length === 0) return;
            track.innerHTML = cards.join('');
            const section = this.closest('[data-rv-section]');
            if (section) section.hidden = false;
            if (window.mnWishlist) window.mnWishlist.paint();
          });
          this.querySelectorAll('.ps3-arrow').forEach((btn) => {
            btn.addEventListener('click', () => {
              track.scrollBy({ left: Number(btn.dataset.dir) * track.clientWidth, behavior: 'smooth' });
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-shopping"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mn-scroller')) {
    customElements.define(
      'mn-scroller',
      class extends HTMLElement {
        connectedCallback() {
          const track = this.querySelector('.mn-scroller-track');
          this.querySelectorAll('.mn-scroller-btn').forEach((btn) => {
            btn.addEventListener('click', () => {
              const dir = Number(btn.dataset.dir) || 1;
              track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
